import { OpenGraphImages } from '@/constants/og';

export const Meta = {
  home: {
    title: 'Home',
    description:
      'Dive into the world of React Native - Discover the resources that helped me start my journey to building React Native animations',
    urlPath: '',
    image: OpenGraphImages.home,
  },
  demos: {
    title: 'Demos',
    description:
      'Explore the beauty of React Native animations with Reanimated, Skia and Gesture Handler',
    urlPath: 'demos',
    image: OpenGraphImages.demos,
  },
  articles: {
    title: 'Articles',
    description:
      'Interactive articles about React Native animations by Reactiive',
    urlPath: 'articles',
    image: OpenGraphImages.articles,
  },
};
